export enum ColorIconEnum {
    INHERIT = "inherit",
    DEFAULT =  "default",
    PRIMARY = "primary",
    SECONDARY = "secondary",
    ERROR = "error",
    INFO = "info",
    SUCCESS = "success",
    WARNING = "warning",
}